import Card from '../Card'

export default class Spell extends Card {
  name = 'Spell'

  pick(picker = this.board!.hero.card) {
    if (!super.pick(picker)) return false

    const hero = this.board!.hero
    const movePickerHere = () => picker.moveTo(this.location!)

    if (picker === hero.card)
      hero.addSpell(this.clone())
    else picker.loot = this.moveTo()
    movePickerHere()
    this.drawCards()

    return true
  }

  clone() {
    return new Spell()
  }
}
